import { breakpoints, fontFamilies } from "@brightagency/headstart-common";
import React, { FC } from "react";
import styled, { css } from "styled-components";
import { buttonResetStyles } from "../../../utils";
import { colors } from "../../../utils/colors";

export const Outer = styled.div`
    margin-bottom: 32px;
    margin-top: -16px;

    ${breakpoints.medium} {
        display: flex;
        align-items: center;
        gap: 16px;
        margin-bottom: 50px;
    }

    ${breakpoints.large} {
        margin-top: -25px;
    }
`;

export const ButtonGroup = styled.div<{ optionTwoSelected: boolean }>`
    position: relative;
    display: flex;
    border: 1.5px solid ${colors.brandMid};
    border-radius: 50px;

    &::before {
        border-radius: 50px;
        position: absolute;
        top: 0;
        left: 0;
        width: 50%;
        height: 100%;
        content: "";
        background-color: ${colors.brandMid};
        transition: 100ms ease all;

        ${({ optionTwoSelected }) =>
            optionTwoSelected &&
            css`
                left: 50%;
            `}
    }

    ${breakpoints.medium} {
        width: 400px;
    }
`;

export const Option = styled.button<{ isSelected: boolean }>`
    ${buttonResetStyles}
    font-size: 12px;
    width: 50%;
    padding: 16px 10px;
    text-align: center;
    z-index: 1;
    color: ${colors.brandMid};
    transition: 100ms ease all;
    font-weight: 500;

    ${({ isSelected }) =>
        isSelected &&
        css`
            color: white;
        `}
`;

export const Title = styled.div`
    font-family: ${fontFamilies.heading} !important;
    font-size: 14px;
    color: ${colors.brandMid};
    font-weight: 700;
    text-align: center;
    margin-bottom: 12px;

    ${breakpoints.medium} {
        margin-bottom: 0;
    }
`;

export const ContentPersonaliser: FC<{
    personalised: boolean;
    onChange: (newValue: boolean) => void;
}> = props => {
    return (
        <Outer>
            <Title>Personalise this page</Title>
            <ButtonGroup optionTwoSelected={props.personalised}>
                <Option
                    isSelected={props.personalised === false}
                    onClick={() => props.onChange(false)}
                >
                    Supporting yourself
                </Option>
                <Option
                    isSelected={props.personalised === true}
                    onClick={() => props.onChange(true)}
                >
                    Supporting someone else
                </Option>
            </ButtonGroup>
        </Outer>
    );
};
